<template>
  <div class="date-input-native">
    <div class="date-input-native__label" v-html="label" />
    <div class="date-input-native__body">
      <Icon icon="calendar" class="date-input-native__icon" />
      <div class="date-input-native__value" @click="focusInput">
        <span v-if="value.isZero()" class="date-input-native__placeholder">{{ placeholder }}</span>
        <span v-else>{{ value.format('DD-MM-YYYY') }}</span>

        <input ref="input" type="date" @change="change" :hidden="!editable"
          :value="initialValue" :min="minDate" :max="maxDate">
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Component from 'vue-class-component'

import Icon from '@/components/Icon.vue'

@Component({
  components: {
    Icon,
  },
  props: {
    value: {
      type: moment.Moment,
      required: true,
    },
    min: {
      type: moment.Moment,
      required: false,
    },
    max: {
      type: moment.Moment,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
    },
    editable: {
      type: Boolean,
      required: false,
      default: () => true,
    },
  },
})
export default class DateInputNative extends Vue {
  get minDate () {
    return this.min.format('YYYY-MM-DD')
  }

  get maxDate () {
    return this.max.format('YYYY-MM-DD')
  }

  get initialValue () {
    return this.value.isZero() ? this.maxDate : this.value.format('YYYY-MM-DD')
  }

  focusInput () {
    this.$refs.input.focus()
    this.$emit('click')
  }

  change (e) {
    this.$emit('input', moment(e.target.value).startOf('day'))
  }
}
</script>

<style lang="scss" scoped>
.date-input-native {
  display: flex;
  flex-direction: column;
  font-weight: lighter;
  color: inherit;
  
  &__label {
    font-size: 12px;
  }
  
  &__value {
    position: relative;
    padding: 5px 0 7px;
    font-size: 13px;

    input {
      position: absolute;
      width: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      padding: 0;
    }
  }

  &__icon {
    float: right;
    position: relative;
    font-size: 18px;
    width: 28px;
    height: 28px;
    text-align: center;
    margin-top: -2px;
  }

  &__body {
    border-bottom: 1px solid #0057A8;
  }
}

.field-invalid .date-input-native__body {
  border-bottom: 1px solid #E71F6C;
}

.date-input--blue-border .date-input-native__body {
  background-image: url('/assets/images/input-box-underline-blue.png');
  background-position-x: right;
  background-position-y: bottom;
  background-repeat: no-repeat;
  user-select: none;
  border-bottom: none;
}

.field-invalid.date-input--blue-border .date-input-native__body {
  background-image: url('/assets/images/input-box-underline-red.png');    
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DateInputWithNativeInput.vue